<template>
  <div>
<!--    <div style="height: 60px;background-color: #1c3784;width: 100%"></div>-->
    <div class="container">
      <div class="row">
        <div class="news_nav">
          <span>主页 > 大赛详情</span>
        </div>
        <div class="col-sm-8 news_content" style="padding-top: 30px;width: 1200px;margin: 0 auto">
          <h2 style="font-size: 30px;text-align: center">全国大学生生态环境管理科研创新大赛</h2>
          <h6 style="margin-bottom: 40px;font-size: 12px;text-align: center">2021年04月 来源：中国生态学学会</h6>
          <p style="font-size: 17px;font-weight: bold">
            （一）参赛对象
          </p>
          <p>
            高校在校本科生、硕士研究生以及博士研究生均可组队报名。每参赛团队学生不多于6人，指导教师不多于2人，成员学历构成不限；自拟赛队名称，并指定联系人。每学生仅限参与1支团队、每指导教师仅限参与2支队伍。
          </p>
          <p style="font-size: 17px;font-weight: bold">
            （二）比赛主题
          </p>
          <p>
            大赛接受以下领域的科研作品参赛，鼓励广泛利用各类数据开展实证分析，鼓励将生态环境科学技术应用于城市规划、产业规划、生产技术优化等领域的跨界应用研究。<br>
            &emsp;&emsp;&emsp;&emsp;[1]&emsp;社会-经济-自然复合生态系统<br>
            &emsp;&emsp;&emsp;&emsp;[2]&emsp;系统生态学<br>
            &emsp;&emsp;&emsp;&emsp;[3]&emsp;生态经济学<br>
            &emsp;&emsp;&emsp;&emsp;[4]&emsp;生态环境与气候变化<br>
            &emsp;&emsp;&emsp;&emsp;[5]&emsp;产业生态与循环经济<br>
            &emsp;&emsp;&emsp;&emsp;[6]&emsp;生态环境管理政策<br>
            &emsp;&emsp;&emsp;&emsp;[7]&emsp;生态环境大数据与应用<br>
            &emsp;&emsp;&emsp;&emsp;[8]&emsp;其他：参赛者认为在生态环境管理框架下，十四五期间应开展的重要研究内容。
          </p>
          <p style="font-size: 17px;font-weight: bold">
            （三）比赛流程
          </p>
          <p>
			  <span style="font-size: 14px;font-weight: bold">
			  &emsp;&emsp;1>报名与摘要初筛</span>
            <br>
            &emsp;&emsp;&emsp;&emsp;[1]&emsp;2021年4月1日-5月1日在活动官网注册并上传摘要报名。<br>
            &emsp;&emsp;&emsp;&emsp;[2]&emsp;2021年5月10日前对报名队伍进行筛选，并邮件通知结果；筛选标准为是否符合大赛主题和参赛对象要求。<br>
            &emsp;&emsp;&emsp;&emsp;[3]&emsp;摘要内容为初步的研究设想，docx格式，1000汉字（或500英语单词）内，图表数目不限。
          </p>
          <p>
				  <span style="font-size: 14px;font-weight: bold">
					  &emsp;&emsp;2>在线公益学术培训</span>
            <br>
            &emsp;&emsp;&emsp;&emsp;[1]&emsp;2021年5月10日-20日举行在线讲座，报名者均可参加。<br>
            &emsp;&emsp;&emsp;&emsp;[2]&emsp;生态环境管理学术报告（0.5天，5-7场报告，含启动仪式。<br>
            &emsp;&emsp;&emsp;&emsp;[3]&emsp;学术规范与文献综述技巧（0.5天，2-3场报告）。<br>
            &emsp;&emsp;&emsp;&emsp;[4]&emsp;生态系统服务评估工具培训（1天）。
          </p>
          <p>
				  <span style="font-size: 14px;font-weight: bold">
					  &emsp;&emsp;3>初稿提交与专家函审</span>
            <br>
            &emsp;&emsp;&emsp;&emsp;[1]&emsp;2021年5月20日-30日在活动官网上传初稿。<br>
            &emsp;&emsp;&emsp;&emsp;[2]&emsp;2021年6月20日前对初稿进行专家函审，并公布20名决赛入选团队。<br>
            &emsp;&emsp;&emsp;&emsp;[3]&emsp;初稿函审关注初稿体现的研究意义、创新性和科学逻辑能力。<br>
            &emsp;&emsp;&emsp;&emsp;[4]&emsp;决赛入选名单及各入选作品摘要在活动管网公示一周。<br>
            &emsp;&emsp;&emsp;&emsp;[5]&emsp;初稿内容为研究详细设计及进展，docx格式，3000汉字（或1500英语单词）内，图表数目不限（需含技术路线图1张）。
          </p>
          <p>
				  <span style="font-size: 14px;font-weight: bold">
					  &emsp;&emsp;4>终稿提交与现场答辩</span>
            <br>
            &emsp;&emsp;&emsp;&emsp;[1]&emsp;2021年7月20日-30日在活动官网上传终稿。<br>
            &emsp;&emsp;&emsp;&emsp;[2]&emsp;2021年下半年择机举行终审答辩，地点待定。<br>
            &emsp;&emsp;&emsp;&emsp;[3]&emsp;终稿答辩关注作品科学性、规范性和作品完成程度。<br>
            &emsp;&emsp;&emsp;&emsp;[4]&emsp;答辩现场颁奖。<br>
            &emsp;&emsp;&emsp;&emsp;[5]&emsp;获奖名单及获奖作品摘要在活动管网公示一周。<br>
            &emsp;&emsp;&emsp;&emsp;[6]&emsp;终稿内容为研究进展及基本研究结论与发现，docx格式，6000汉字（或3000英语单词）内，图表数目不限（需含技术路线图1张），需详细说明数据出处，说明各成员贡献。<br>
            &emsp;&emsp;&emsp;&emsp;[7]&emsp;答辩内容为作品的主要工作内容、创新点、主要结论和发现；20分钟讲述，10分钟答疑；pptx格式。
          </p>

          <p style="font-size: 17px;font-weight: bold">
            （四）作品要求
          </p>
          <p>
            &emsp;&emsp;[1]&emsp;中英文不限，获一、二、三等奖的中文作品后期经翻译后也可推荐英文杂志发表<br>
            &emsp;&emsp;&emsp;&emsp;[2]&emsp;参赛作品需为未投稿及未公开发表（含网络）的作品<br>
            &emsp;&emsp;&emsp;&emsp;[3]&emsp;参赛团队独立完成，终稿“致谢”中需覆盖所有利益相关方<br>
            &emsp;&emsp;&emsp;&emsp;[4]&emsp;参赛作品及其采用数据资料无版权纠纷和潜在版权纠纷<br>
            &emsp;&emsp;&emsp;&emsp;[5]&emsp;禁止抄袭他人成果、禁止伪造学术数据和过程、引用成果需指明出处<br>
            &emsp;&emsp;&emsp;&emsp;[6]&emsp;内容需要有详细的计算或调研过程，以及充分的论证<br>
            &emsp;&emsp;&emsp;&emsp;[7]&emsp;按照大赛组委会规定的格式进行排版（见附件1，首页公告栏置顶）
          </p>

          <p style="font-size: 17px;font-weight: bold">
            （五）奖项设置
          </p>
          <p>
            &emsp;&emsp;[1]&emsp;一等奖：1队，获奖证书、奖品及推荐发表/开发<br>
            &emsp;&emsp;&emsp;&emsp;[2]&emsp;二等奖：3队，获奖证书、奖品及推荐发表/开发<br>
            &emsp;&emsp;&emsp;&emsp;[3]&emsp;三等奖：6队，获奖证书、奖品及推荐发表/开发<br>
            &emsp;&emsp;&emsp;&emsp;[4]&emsp;优秀奖：10队，获奖证书<br>
            &emsp;&emsp;&emsp;&emsp;[5]&emsp;指导教师奖：一、二、三等奖的指导教师获得，获奖证书及奖品
          </p>

        </div>

      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "viewDetails"
  }
</script>

<style scoped>
  /** {*/
  /*  margin: 0;*/
  /*  padding: 0;*/
  /*}*/
  .news_nav {
    font-size: 15px;
    color: #333;
    line-height: 30px;
    margin: 30px auto;
    padding-bottom: 30px;
    border-bottom: 1px solid #eee;
    width: 1200px;
    text-align: right
  }

  .news_content p {
    font-size: 14px;
    line-height: 32px;
    margin-bottom: 25px;
    text-indent: 2em;
  }
</style>



// WEBPACK FOOTER //
// src/page/Layout/viewDetails.vue